'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLoyalty = function MdLoyalty(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 25.5c0.7-0.8 1.2-1.8 1.2-3 0-2.3-1.9-4.1-4.1-4.1-1.2 0-2.2 0.4-3 1.1l-1.3 1.3-1.1-1.3c-0.8-0.8-1.8-1.1-3-1.1-2.3 0-4.1 1.8-4.1 4.1 0 1.2 0.4 2.2 1.1 3l7.1 7.1z m-19.7-13.9c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m26.6 7.7c0.6 0.6 0.9 1.4 0.9 2.3s-0.3 1.8-0.9 2.4l-11.7 11.7c-0.6 0.6-1.4 0.9-2.4 0.9s-1.7-0.3-2.3-0.9l-15-15c-0.6-0.6-0.9-1.4-0.9-2.3v-11.8c0-1.8 1.4-3.2 3.2-3.2h11.8c0.9 0 1.7 0.3 2.3 0.9z' })
        )
    );
};

exports.default = MdLoyalty;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/loyalty.js
// module id = 1727
// module chunks = 168707334958949